


function watchForElement(el, method) {
  chkDelay = '200'; // Amount of time between Checks
  var chkExist = setInterval(function() {
    chkClass = $(el);
    if (chkClass.length) {
      // DO something
      clearInterval(chkExist);
      method(chkClass)
    }
  }, chkDelay);
}

// var chkEl = '[data-testid="ShopifyPay-button"]';
// watchForElement(chkEl,function(el) {
//   el.parent().hide()
// })


// watchForElement('#shopify-section-header', function(el) {
//   updateHeightVar('#shopify-section-header', '--header-height')
// })
// watchForElement('#shopify-section-announcement-bar', function(el) {
//   updateHeightVar('#shopify-section-announcement-bar', '--announce-height')
// })

function updateHeightVar(el, v) {
  let prevH;
  let itm = document.querySelector(el);

  initH()

  window.addEventListener('resize', runTwice);
  window.addEventListener('scroll', runTwice);

  function runTwice() {
    initH()
    setTimeout(function() {
      initH()
    }, 100)
  }

  function initH() {
    var H = itm.clientHeight;
    if (H != prevH) {
      // console.log('run')
      // Then we set the value in the --header-height custom property to the root of the document
      document.documentElement.style.setProperty(v, `${H}px`);
      prevH = H;
    }
  }
}

function Modal(el) {
  el = el;
  act = 'active';
  actMod = 'modal-active';
  initMdl(el)

  function initMdl(el) {
    winWidth = $(window).width();
    thisEl = el;
    type = getDataName($(thisEl)).length ? getDataName($(thisEl)) : 'modal';
    thisMdl = getDataName($(thisEl)).length ? $('[data-modal="' + $(thisEl).data(type) + '"]') : $(thisEl);
    if (type == 'open' || type == 'modal') {
      if (!thisMdl.is('.' + act)) {
        showModal(thisMdl);
      } else {
        hideModal(thisMdl);
      }
    }
    if (type == 'close') {
      hideModal(thisMdl);
    }
  }

  function showModal(el) {
    var lastTop = $(window).scrollTop(),
      el = $(el),
      delay = 0;
    $('body').addClass(actMod).css({ top: -lastTop });
    if (el.is('[style*=display]')) {
      el[0].removeAttribute('style');
      delay = 100; // gives a moment for animation settings to take over
    }
    setTimeout(function() {
      el.addClass(act);
      el.find(':focusable').first().focus();
    }, delay)
  }

  function hideModal(el) {
    var lastTop = Math.abs(parseInt($('body').css('top'))),
      el = $(el);
    $('body').css({ top: 0 }).removeClass(actMod);
    window.scrollTo(0, lastTop);
    el.removeClass(act);
  }

  function getDataName(node) {
    var d = {},
      key = '',
      re_dataAttr = /^data\-(.+)$/;
    $.each(node.get(0).attributes, function(index, attr) {
      if (re_dataAttr.test(attr.nodeName)) {
        key = attr.nodeName.match(re_dataAttr)[1];
      }
    });
    return key;
  }
}

console.log('test')


waitFor_jQuery(function() {


  jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector) {
      return $(el).is('a, button, :input, label, [tabindex]');
    }
  });


  // Accordian
  $('#tabs-select').on('change', function() {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      // window.location = url; // redirect
      $('a[href="' + url + '"]').trigger('click');
    }
    return false;
  });

  // sidebar links
  $('.accordion-section .sidebar-link').on('click  touch', function() {
    // body...
    $('.accordion-section .sidebar-link').removeClass('active');
    $(this).addClass('active');
  })
  // Accordian
  $(document).on('touch click', '.acc-btn', function() {
    var btn = '.acc-btn',
      animTime = 300,
      justClickedDelay = 500,
      justClicked = false,
      active = 'selected',
      cont = '.acc-content',
      ttlTxt = 'h3',
      imgItm = '.img',
      clckdIndx = $(this).index(btn),
      inrChldHght = $(cont).children().eq(clckdIndx).outerHeight(),
      $thsTtl = $(this).find(ttlTxt),
      $thsImg = $(this).find(imgItm),
      isOpen = $thsTtl.hasClass(active),
      winWidth = $(window).width(),
      clearItem = $('#shopify-section-header'),
      actTab = $(ttlTxt + '.' + active),
      actTabTop = !!actTab ? '' : actTab[0].getBoundingClientRect().top + window.scrollY;
    if (!!clearItem && !!actTab) {
      actTabTop = actTabTop + clearItem.outerHeight(true) + 15;
    }
    if (!justClicked) {
      justClicked = true;
      if (isOpen) {
        removeClasses();
        openClose();
        // console.log('close')
      } else {
        // console.log('open')
        removeClasses();
        addClasses();
        openClose(true);
        // mobScroll();
      }
      setTimeout(function() {
        justClicked = false;
      }, justClickedDelay);
    }

    function mobScroll() {
      if (winWidth < 750) {
        setTimeout(function() {
          console.log(openTabDist)
          $([document.documentElement, document.body]).animate({
            scrollTop: openTabDist
          }, animTime);
        }, animTime * 2.5);
      }
    }

    function removeClasses() {
      $(btn + ' ' + ttlTxt).removeClass(active);
      $(btn + ' ' + imgItm).removeClass(active);
    }

    function addClasses() {
      $thsTtl.addClass(active);
      $thsImg.addClass(active);
    }

    function zeroHght() {
      $(cont).stop().animate({ height: 0 }, animTime);
    }

    function setHght() {
      $(cont).eq(clckdIndx).stop().animate({ height: inrChldHght }, animTime);
    }

    function openClose(dir) {
      if (dir == 'open' || dir == true) {
        zeroHght()
        setHght()
      } else {
        setHght()
        zeroHght()
      }
    }
  });


  // on load
  thisHash = window.location.hash;
  clearThis = $('#shopify-section-header').height() + $('#shopify-section-announcement-bar').height() + 25;

  // removes hash from href
  // history.pushState(thisHash, '', window.location.pathname);
  if (thisHash.length > 0) {
    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $(thisHash).offset().top - clearThis
      }, 1000);
    }, 200)
  }
  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#recover"]')
    .not('[href="#login"]')
    .not('[href="#0"]')
    .click(function(event) {

      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - clearThis
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });


  var actLogin = 'active';
  if (thisHash.length > 0 && thisHash == '#recover') {
    $('.' + actLogin).removeClass(actLogin);
    $(thisHash).addClass(actLogin);
  }
  $('[href="#recover"],[href="#login"]').click(function(e) {
    e.preventDefault()
    var tar = $(this).attr('href');
    $('.' + actLogin).removeClass(actLogin);
    $(tar).addClass(actLogin);
  })

  $('a')
    .not('#boldmetrics-ssc-activator')
    .not('.img-tab-link-2') // .not() ignores anchors with this class
    .not('[href*="tel:"]')
    .not('[href*="mailto:"]')
    .not('.product-single__thumbnail')
    .not('[href="#recover"]')
    .not('[href="#login"]')
    .not(img.ProductImage) //VS edited 2023.04.27 for popping out new tabs for product images.
    .each(function() {
      var a = new RegExp('/' + window.location.host + '/');
      if (!a.test(this.href)) {
        $(this).click(function(event) {
          if (!$(this).is('#boldmetrics-ssc-activator')) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, '_blank');
          }
        });
      }
    });


  // show/hide back to top
  backToTop()

  $(document).scroll(function() {
    backToTop()
  });
  $(document).resize(function() {
    backToTop()
  });

  function backToTop() {
    var topBtn = $('.back-to-top'),
      act = 'show-top',
      fromTop = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop,
      minDist = window.innerHeight * 0.75;
    if (fromTop > minDist) {
      topBtn.addClass(act)
    } else {
      topBtn.removeClass(act)
    }
  }


  $('.js-filters-toggle').click(function(e) {
    $('html').toggleClass('filters-is-open');
    e.preventDefault();
  });


  $(document).ready(function() {
    $('.modal-action').on('click touch', function(e) {
      e.preventDefault();
      Modal($(this));
      // console.log($(this))

      var vid = $(this).closest('.video-modal').find('iframe');
      if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
        var vidSrc = vid.attr('src');
        // console.log(vidSrc)
        vid.attr('src', vidSrc);
      }
    })


    $('.btn-modal').on('click touch', function() {

      var thsId = $(this).attr('href');

      Modal($(thsId));
      // console.log($(thsId))

      var vid = $(thsId).find('iframe');
      if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
        var vidSrc = vid.attr('src');
        // console.log(vidSrc)
        vid.attr('src', vidSrc);
      }
    })
  })

  videoRatio()

  function videoRatio() {
    var vid = $('.video-ratio:not(.for-modal) iframe, .video-ratio:not(.for-modal) video');

    initRatio();
    $(window).resize(function() {
      initRatio();
    })

    function initRatio() {
      var winWdth = $(window).width(),
        ratio = 0.56;

      if (vid.length) {
        vid.each(function() {
          var thsVid = $(this);

          if (typeof thsVid.data('video-ratio') !== 'undefined') {
            var ratio = thsVid.data('video-ratio');
          }
          var thsVidPar = thsVid.closest('div'),
            thsVidParHght = thsVidPar.outerHeight(true),
            cssHght = thsVidParHght,
            cssWdth = cssHght / ratio;

          if (cssWdth < winWdth) {
            var cssWdth = winWdth,
              cssHght = cssWdth * ratio;
          }

          thsVid.attr('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')

        })
      }
    }
  }




  $('.rte iframe').each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
  });


});